import(/* webpackMode: "eager" */ "/var/www/checkin/frontend/app/page.tsx");
